module.exports = __webpack_public_path__ + "static/media/undraw_selected_options_42hx.b893d3d7.svg";